import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import EditIcon from '@material-ui/icons/Edit';

const styles = {
  leftIcon: {
    padding: '0px 5px'
  }
};

const enhance = compose();

const button = enhance(({ classes, params, onClickAction }) => {
  return (
    <Button
      color="primary"
      onClick={() => {
        onClickAction(params);
      }}
    >
      <EditIcon className={classes.leftIcon} />
      編集
    </Button>
  );
});

export default withRouter(withStyles(styles)(button));
